import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "form-horizontal",
  role: "form"
}
const _hoisted_3 = { class: "form-body" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6 col-12 form-check d-flex align-items-center mb-3" }
const _hoisted_6 = {
  for: "send-by-email",
  class: "form-check-label control-label"
}
const _hoisted_7 = { class: "col-md-6 col-12 form-check d-flex align-items-center mb-3" }
const _hoisted_8 = {
  for: "send-by-sms",
  class: "form-check-label control-label"
}
const _hoisted_9 = { class: "col-md-6 col-12 form-check d-flex align-items-center mb-3" }
const _hoisted_10 = {
  for: "send-by-mercure",
  class: "form-check-label control-label"
}
const _hoisted_11 = { class: "col-md-6 col-12 form-check d-flex align-items-center mb-3" }
const _hoisted_12 = {
  for: "ignition",
  class: "form-check-label control-label"
}
const _hoisted_13 = { class: "col-md-6 col-12 form-check d-flex align-items-center mb-3" }
const _hoisted_14 = {
  for: "satellites",
  class: "form-check-label control-label"
}
const _hoisted_15 = { class: "row mt-3 input-section" }
const _hoisted_16 = { class: "col-md-6 col-12" }
const _hoisted_17 = { class: "form-check d-flex align-items-center mb-2" }
const _hoisted_18 = {
  for: "speed-checkbox",
  class: "form-check-label control-label"
}
const _hoisted_19 = ["disabled", "placeholder"]
const _hoisted_20 = { class: "validation-space" }
const _hoisted_21 = {
  key: 0,
  class: "invalid-feedback mt-2 d-block"
}
const _hoisted_22 = { class: "col-md-6 col-12" }
const _hoisted_23 = { class: "form-check d-flex align-items-center mb-2" }
const _hoisted_24 = {
  for: "voltage-checkbox",
  class: "form-check-label control-label"
}
const _hoisted_25 = ["disabled", "placeholder"]
const _hoisted_26 = { class: "validation-space" }
const _hoisted_27 = {
  key: 0,
  class: "invalid-feedback mt-2 d-block"
}
const _hoisted_28 = { class: "pull-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    ref: "core",
    nested: false
  }, {
    header: _withCtx(() => [
      (_ctx.isEdit && _ctx.imei)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(_ctx.$t('components.notificationsSettings.modals.editNotification')) + " " + _toDisplayString(_ctx.imei), 1))
        : _createCommentVNode("", true)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "send-by-email",
                name: "send_by_email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.notificationSetting.send_by_email) = $event)),
                class: "form-check-input me-2"
              }, null, 512), [
                [_vModelCheckbox, _ctx.notificationSetting.send_by_email]
              ]),
              _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('components.notificationsSettings.dataGrids.sendByEmail')), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "send-by-sms",
                name: "send_by_sms",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.notificationSetting.send_by_sms) = $event)),
                class: "form-check-input me-2"
              }, null, 512), [
                [_vModelCheckbox, _ctx.notificationSetting.send_by_sms]
              ]),
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('components.notificationsSettings.dataGrids.sendBySms')), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "send-by-mercure",
                name: "send_by_mercure",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.notificationSetting.send_by_mercure) = $event)),
                class: "form-check-input me-2"
              }, null, 512), [
                [_vModelCheckbox, _ctx.notificationSetting.send_by_mercure]
              ]),
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('components.notificationsSettings.dataGrids.sendByMercure')), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "ignition",
                name: "ignition",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.notificationSetting.ignition) = $event)),
                class: "form-check-input me-2"
              }, null, 512), [
                [_vModelCheckbox, _ctx.notificationSetting.ignition]
              ]),
              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('components.notificationsSettings.modals.ignition')), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: "satellites",
                name: "satellites",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.notificationSetting.satellites) = $event)),
                class: "form-check-input me-2"
              }, null, 512), [
                [_vModelCheckbox, _ctx.notificationSetting.satellites]
              ]),
              _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('components.notificationsSettings.modals.satellites')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "speed-checkbox",
                  name: "speed-checkbox",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isSpeedChecked) = $event)),
                  class: "form-check-input me-2"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.isSpeedChecked]
                ]),
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('components.notificationsSettings.modals.speed')), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "speed-input",
                name: "speed",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.notificationSetting.speed.$model) = $event)),
                disabled: !_ctx.isSpeedChecked,
                class: _normalizeClass(["form-control", {
                  'text-muted': !_ctx.isSpeedChecked,
                  'is-invalid':
                    _ctx.v$.notificationSetting.speed.$error &&
                    _ctx.v$.notificationSetting.speed.$dirty,
                }]),
                onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.notificationSetting.speed.$touch())),
                placeholder: !_ctx.isSpeedChecked ? _ctx.$t('components.notificationsSettings.modals.enterSpeed') : ''
              }, null, 42, _hoisted_19), [
                [_vModelText, _ctx.v$.notificationSetting.speed.$model]
              ]),
              _createElementVNode("div", _hoisted_20, [
                (
                    _ctx.v$.notificationSetting.speed.$error &&
                      _ctx.v$.notificationSetting.speed.$dirty
                  )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.notificationSetting.speed.$errors, (error) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: error.$uid
                        }, _toDisplayString(error.$message), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "voltage-checkbox",
                  name: "voltage-checkbox",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isVoltageChecked) = $event)),
                  class: "form-check-input me-2"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.isVoltageChecked]
                ]),
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('components.notificationsSettings.modals.voltage')), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "voltage-input",
                name: "voltage",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.v$.notificationSetting.voltage.$model) = $event)),
                disabled: !_ctx.isVoltageChecked,
                class: _normalizeClass(["form-control", {
                  'text-muted': !_ctx.isVoltageChecked,
                  'is-invalid':
                    _ctx.v$.notificationSetting.voltage.$error &&
                    _ctx.v$.notificationSetting.voltage.$dirty,
                }]),
                onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.notificationSetting.voltage.$touch())),
                placeholder: !_ctx.isVoltageChecked ? _ctx.$t('components.notificationsSettings.modals.enterVoltage') : ''
              }, null, 42, _hoisted_25), [
                [_vModelText, _ctx.v$.notificationSetting.voltage.$model]
              ]),
              _createElementVNode("div", _hoisted_26, [
                (
                    _ctx.v$.notificationSetting.voltage.$error &&
                      _ctx.v$.notificationSetting.voltage.$dirty
                  )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.notificationSetting.voltage.$errors, (error) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: error.$uid
                        }, _toDisplayString(error.$message), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("button", {
          class: "btn btn-default",
          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fa fa-remove" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.vehicles.modals.exit')), 1)
        ]),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.saveNotificationSetting && _ctx.saveNotificationSetting(...args)))
        }, [
          _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fa fa-save" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.vehicles.modals.save')), 1)
        ])
      ])
    ]),
    _: 1
  }, 512))
}